import HttpRepository from './httpRepository';

import type { companyPropertiesConstants } from '../constants/appConstants';

type CompanyRepository = {
	saveCompanyName: ({ companyName }: { companyName: string }) => Promise<void>;
	getCompanyFeatures: () => Promise<any>;
	saveCompanyFeature: ({ key, value }: { key: string; value: string }) => Promise<void>;
	getCompanyProperty: ({
		companyAccountId,
		propertyKey,
	}: {
		companyAccountId: string;
		propertyKey: string;
	}) => Promise<typeof companyPropertiesConstants>;
	saveCompanyProperty: ({
		companyId,
		key,
		value,
	}: {
		companyId: string;
		key: string;
		value: string | number | boolean | string[];
	}) => Promise<void>;
	getCompanyPropertyWhitelistedDomains: ({ companyId }: { companyId: string }) => Promise<any>;
	saveCompanyPropertyWhitelistedDomain: ({
		companyId,
		domain,
	}: {
		companyId: string;
		domain: string | number | boolean | string[];
	}) => Promise<void>;
	deleteCompanyPropertyWhitelistedDomain: ({
		companyId,
		domain,
	}: {
		companyId: string;
		domain: string | number | boolean | string[];
	}) => Promise<void>;
	// fot other options to add in the future
	// {
	// 		companyId = auth.companyAccountId,
	// 		limit = 10000 which is max,
	// 		page = 0,
	// 		includeMemberships: _includeMemberships,
	// 		query,
	// 		userIds,
	// 	}
	getCompanyUsers: (params: { limit: number }) => Promise<void>;
};

const CompanyRepository: CompanyRepository = {
	saveCompanyName: ({ companyName }) => HttpRepository.tradeshiftGo().put('/rest/company/companyName', { companyName }),
	getCompanyFeatures: () =>
		HttpRepository.tradeshiftGo()
			.get('/rest/features')
			.then(response => response.data),
	saveCompanyFeature: ({ key, value }) => HttpRepository.tradeshiftGo().put(`/rest/features/${key}`, `${value}`),
	getCompanyProperty: ({ companyAccountId, propertyKey }) =>
		HttpRepository.tradeshiftGo()
			.get(`/rest/company/${companyAccountId}/properties/${propertyKey}`)
			.then(response => response.data),
	saveCompanyProperty: ({ companyId, key, value }) =>
		HttpRepository.tradeshiftGo().put(`/rest/company/${companyId}/properties/${key}`, {
			propertyKey: key,
			propertyValue: value,
		}),
	getCompanyPropertyWhitelistedDomains: ({ companyId }) =>
		HttpRepository.tradeshiftGo()
			.get(`/rest/company/${companyId}/whitelisteddomains/`)
			.then(response => response.data),
	saveCompanyPropertyWhitelistedDomain: ({ companyId, domain }) =>
		HttpRepository.tradeshiftGo().post(`/rest/company/${companyId}/whitelisteddomains`, { newDomain: domain }),
	deleteCompanyPropertyWhitelistedDomain: ({ companyId, domain }) =>
		HttpRepository.tradeshiftGo().delete(`/rest/company/${companyId}/whitelisteddomains`, {
			data: { domain },
		}),
	getCompanyUsers: async params => {
		const response = await HttpRepository.tradeshiftGo().get('/rest/company/users', { params });
		return response.data;
	},
};

export default CompanyRepository;
